import React, { useContext, useMemo, useEffect } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import { CusButton } from '../../Components/From/Button';
import { FormattedMessage } from 'react-intl';
import { Global } from '../../App';
import moment from 'moment';
import qs from 'querystring';
import '../pages.scss';
// switch lang
import { countryCodeToCode, langCodeToString } from '../../Share/Tools/switchLang';
// api
import { postQRCodeVerifyQueue } from '../../Api/VerifyQueue';

function QRCodeSuccessPage(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const { state } = props.location;
  const { orderInfo } = globalState.customer;

  // 防止直接進入此頁面
  // if (
  //   !orderInfo ||
  //   !orderInfo.country ||
  //   !orderInfo.orderTime ||
  //   !orderInfo.queueNumber ||
  //   !orderInfo.selectedBranch
  // ) {
  //   props.history.push('/');
  //   dispatchGlobal({
  //     type: 'RESET'
  //   });
  // }
  const checkURL = useMemo(() => {
    const { search } = props.location;
    if (search !== '' && search !== undefined && search !== null) {
      const par = qs.parse(search.split('?')[1]);
      return par;
    } else {
      return '';
    }
  }, [props.location.search]);

  useEffect(() =>{
    const {queueNumber, queueCode} = globalState.customer.orderInfo;
    if(queueNumber != String(checkURL.queueNumber) || queueCode != checkURL.queueCode){
      dispatchGlobal({ type: 'RESET' });
    }
  },[])

  useEffect(() => {
    dispatchGlobal({
      type: 'UPDATE',
      payload: [
        { key: 'langType', val: langCodeToString(Number(checkURL.langID || 1)) }
      ]
    });
  }, [checkURL.langID]);

  return (
    <div className="Pages">
      <Header />
      <div className="TakeOrder col d-flex flex-column  align-items-center p-0 pt-3">
        <div className='w-100 h-50 border-bottom border-light d-flex flex-column justify-content-center'>
        <CusButton
          className="w-100 mt-2 mb-2 p-3"
          children={<FormattedMessage id="pages.QRCodeSuccess.buttonToOrder" />}
          onClick={() => {
            if (checkURL &&
              checkURL.queueCode &&
              checkURL.queueNumber &&
              checkURL.storeID) {
              props.history.push(`/?queueCode=${checkURL.queueCode}&queueNumber=${String(checkURL.queueNumber)}&storeID=${checkURL.storeID}`);
            } else {
              props.history.push('/');
              // dispatchGlobal({
              //   type: 'UPDATE',
              //   payload: [
              //     {
              //       key: 'customer',
              //       val: {
              //         ...globalState.customer,
              //         currentStep: '2'
              //       }
              //     }
              //   ]
              // });
            }
          }}
        />
        </div>
        <div className='w-100 h-50 d-flex flex-column justify-content-end'>
        <CusButton.White
          className="w-100 mt-2 mb-2 p-3"
          children={<FormattedMessage id="pages.QRCodeSuccess.NumberSearch" />}
          onClick={() => {
            const url = "https://www.dintaifung.tw/Queue/?type=3&s=" + checkURL.storeID+"&d=1"
            window.open(url);
          }}
        />
        <CusButton.White
          className="w-100 mt-2 mb-2 p-3"
          children={<FormattedMessage id="pages.QRCodeSuccess.buttonUseAPP" />}
          onClick={() => {
            window.open(`/OpenOrDownloadApp`);
          }}
        />
       {/* <a href={"https://www.dintaifung.tw/Queue/?type=3&s=" + checkURL.storeID+"&d=1"} target="_blank" rel="noreferrer noopener" className="regularFont">
          { <FormattedMessage id="pages.QRCodeSuccess.NumberSearch" /> }          
        </a> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default QRCodeSuccessPage;
